import {Tag} from "../types";
import React from "react";
import {HiOutlineRefresh} from "react-icons/hi";
import {parseTransferContent} from "./utils";

interface TransferSectionProps {
  stableKey: string;
  tag: Tag;
}

const TransferSection: React.FC<TransferSectionProps> = ({ stableKey, tag }) => {

  return (
    <div key={stableKey} className="transfer-section timeline-node">
      <div className="transfer-header">
        <div className="transfer-title">
          <HiOutlineRefresh className="w-3 h-3" />
          <span>{tag.text || parseTransferContent(tag.content) || 'Transfer'}</span>
          {tag.isStreaming && (
            <div className="thinking-dots">
              <div className="thinking-dot" />
              <div className="thinking-dot" />
              <div className="thinking-dot" />
            </div>
          )}
        </div>
      </div>
      {/* Intentionally no body; title already shows the dispatching text */}
    </div>
  );
}

export default TransferSection;